import { useParams } from "react-router-dom";
import DietaryPreferenceService from "../../../services/DietaryPreferenceService";
import { DietaryPreference } from "../../../models";
import { useEffect, useState } from "react";
import NotFound from "../../../components/not-found";
import Breadcrumbs from "../../../components/breadcrumbs";
import DietaryPreferenceEditForm from "./ui/dietary-preference-edit-form";
import DietaryPreferenceSkeleton from "./skeleton/dietary-preference-skeleton";

export default function DietaryPreferenceEditPage(){
     const { id } = useParams();
      const api = new DietaryPreferenceService();
      const [dietaryPreference, setDietaryPreference] = useState<DietaryPreference>();
      const [loading, setLoading] = useState(true);
      useEffect(() => { 
        fetchDietaryPreference();
      }, []);
      console.log({id})
      const fetchDietaryPreference = async () => {
        if (id) {
          const data = await api.getDietaryPreferenceById(id);
          setDietaryPreference(data);
          setLoading(false);
          
        }
      };

      if (!dietaryPreference && !loading) return <NotFound message="Dietary Preference not found." />;
    
      return (
        <main className="max-w-3xl ">
          <Breadcrumbs
            breadcrumbs={[
              { label: "Dietary Preferences", href: "/admin/dietary-preferences" },
              {
                label: "Edit",
                href: `/admin/dietary-preferences/edit/${id}`,
                active: true,
              },
            ]}
          />
          {!loading && dietaryPreference ? (
            <DietaryPreferenceEditForm dietaryPreference={dietaryPreference} />
          ) : (
            <DietaryPreferenceSkeleton />
          )}
        </main>
      );
    }



